/**
 * @fileoverview äºä»¶å¤çå¨
 * @author dxq613@gmail.com
 */
import GraphEvent from './graph-event';
import { each, isParent } from '../util/util';
var CLICK_OFFSET = 40;
var LEFT_BTN_CODE = 0;
var DELEGATION_SPLIT = ':';
var EVENTS = [
    'mousedown',
    'mouseup',
    'dblclick',
    'mouseout',
    'mouseover',
    'mousemove',
    'mouseleave',
    'mouseenter',
    'touchstart',
    'touchmove',
    'touchend',
    'dragenter',
    'dragover',
    'dragleave',
    'drop',
    'contextmenu',
    'mousewheel',
];
// æ¯å¦æå§æäºä»¶çå¬
function hasDelegation(events, type) {
    for (var key in events) {
        if (events.hasOwnProperty(key) && key.indexOf(DELEGATION_SPLIT + type) >= 0) {
            return true;
        }
    }
    return false;
}
// è§¦åç®æ äºä»¶ï¼ç®æ åªè½æ¯ shape æ canvas
function emitTargetEvent(target, type, eventObj) {
    eventObj.name = type;
    eventObj.target = target;
    eventObj.currentTarget = target;
    eventObj.delegateTarget = target;
    target.emit(type, eventObj);
}
// äºä»¶åæ³¡, enter å leave éè¦å¯¹ fromShape å toShape è¿è¡å¤å
function bubbleEvent(container, type, eventObj) {
    if (eventObj.bubbles) {
        var relativeShape = void 0;
        var isOverEvent = false;
        if (type === 'mouseenter') {
            relativeShape = eventObj.fromShape;
            isOverEvent = true;
        }
        else if (type === 'mouseleave') {
            isOverEvent = true;
            relativeShape = eventObj.toShape;
        }
        // canvas ä¸ç mouseenterï¼ mouseleave äºä»¶ï¼ä»å½è¿å¥æèç§»åº canvas æ¶è§¦å
        if (container.isCanvas() && isOverEvent) {
            return;
        }
        // å¦æç¸å³å¾å½¢åå½åå¾å½¢å¨åä¸ä¸ªå®¹å¨åï¼ä¸è§¦åäºä»¶
        if (relativeShape && isParent(container, relativeShape)) {
            // é»æ­¢ç»§ç»­åä¸åæ³¡
            eventObj.bubbles = false;
            return;
        }
        // äºä»¶åç§°å¯è½å¨å§æè¿ç¨ä¸­è¢«ä¿®æ¹ï¼å æ­¤äºä»¶åæ³¡æ¶éè¦éæ°è®¾ç½®äºä»¶åç§°
        eventObj.name = type;
        eventObj.currentTarget = container;
        eventObj.delegateTarget = container;
        container.emit(type, eventObj);
    }
}
var EventController = /** @class */ (function () {
    function EventController(cfg) {
        var _this = this;
        // æ­£å¨è¢«ææ½çå¾å½¢
        this.draggingShape = null;
        this.dragging = false;
        // å½åé¼ æ /touchæå¨ä½ç½®çå¾å½¢
        this.currentShape = null;
        this.mousedownShape = null;
        this.mousedownPoint = null;
        // ç»ä¸å¤çææçåè°
        this._eventCallback = function (ev) {
            var type = ev.type;
            _this._triggerEvent(type, ev);
        };
        // å¨ document å¤çææ½å°ç»å¸å¤çäºä»¶ï¼å¤çä»å¾å½¢ä¸ç§»é¤ç»å¸æªè¢«ææçé®é¢
        this._onDocumentMove = function (ev) {
            var canvas = _this.canvas;
            var el = canvas.get('el');
            if (el !== ev.target) {
                // ä¸å¨ canvas ä¸ç§»å¨
                if (_this.dragging || _this.currentShape) {
                    var pointInfo = _this._getPointInfo(ev);
                    // è¿å¨ææ½è¿ç¨ä¸­
                    if (_this.dragging) {
                        _this._emitEvent('drag', ev, pointInfo, _this.draggingShape);
                    }
                    // è¯´æä»æä¸ªå¾å½¢ç´æ¥ç§»å¨å°äºç»å¸å¤é¢ï¼
                    // ä¿®å¤äº mouseleave ç bug åä¸ååºç°è¿ç§æåµ
                    // if (this.currentShape) {
                    //   this._emitEvent('mouseleave', ev, pointInfo, this.currentShape, this.currentShape, null);
                    //   this.currentShape = null;
                    // }
                }
            }
        };
        // å¨ document ä¸å¤çææ½å°å¤é¢ï¼éæ¾é¼ æ æ¶è§¦å dragend
        this._onDocumentMouseUp = function (ev) {
            var canvas = _this.canvas;
            var el = canvas.get('el');
            if (el !== ev.target) {
                // ä¸å¨ canvas ä¸ç§»å¨
                if (_this.dragging) {
                    var pointInfo = _this._getPointInfo(ev);
                    if (_this.draggingShape) {
                        // å¦æå­å¨ææ½çå¾å½¢ï¼åä¹è§¦å drop äºä»¶
                        _this._emitEvent('drop', ev, pointInfo, null);
                    }
                    _this._emitEvent('dragend', ev, pointInfo, _this.draggingShape);
                    _this._afterDrag(_this.draggingShape, pointInfo, ev);
                }
            }
        };
        this.canvas = cfg.canvas;
    }
    EventController.prototype.init = function () {
        this._bindEvents();
    };
    // æ³¨åäºä»¶
    EventController.prototype._bindEvents = function () {
        var _this = this;
        var el = this.canvas.get('el');
        each(EVENTS, function (eventName) {
            el.addEventListener(eventName, _this._eventCallback);
        });
        if (document) {
            // å¤çç§»å¨å°å¤é¢æ²¡æè§¦å shape mouse leave çäºä»¶
            // å¤çææ½å°å¤é¨çé®é¢
            document.addEventListener('mousemove', this._onDocumentMove);
            // å¤çææ½è¿ç¨ä¸­å¨å¤é¨éæ¾é¼ æ çé®é¢
            document.addEventListener('mouseup', this._onDocumentMouseUp);
        }
    };
    // æ¸çäºä»¶
    EventController.prototype._clearEvents = function () {
        var _this = this;
        var el = this.canvas.get('el');
        each(EVENTS, function (eventName) {
            el.removeEventListener(eventName, _this._eventCallback);
        });
        if (document) {
            document.removeEventListener('mousemove', this._onDocumentMove);
            document.removeEventListener('mouseup', this._onDocumentMouseUp);
        }
    };
    EventController.prototype._getEventObj = function (type, event, point, target, fromShape, toShape) {
        var eventObj = new GraphEvent(type, event);
        eventObj.fromShape = fromShape;
        eventObj.toShape = toShape;
        eventObj.x = point.x;
        eventObj.y = point.y;
        eventObj.clientX = point.clientX;
        eventObj.clientY = point.clientY;
        eventObj.propagationPath.push(target);
        // äºä»¶çx,yåºè¯¥æ¯åºäºç»å¸å·¦ä¸è§çï¼ä¸canvasçmatrixæ å³
        return eventObj;
    };
    // æ ¹æ®ç¹è·åå¾å½¢ï¼æåæç¬ç«æ¹æ³ï¼ä¾¿äºåç»­ä¼å
    EventController.prototype._getShape = function (point, ev) {
        return this.canvas.getShape(point.x, point.y, ev);
    };
    // è·åäºä»¶çå½åç¹çä¿¡æ¯
    EventController.prototype._getPointInfo = function (ev) {
        var canvas = this.canvas;
        var clientPoint = canvas.getClientByEvent(ev);
        var point = canvas.getPointByEvent(ev);
        return {
            x: point.x,
            y: point.y,
            clientX: clientPoint.x,
            clientY: clientPoint.y,
        };
    };
    // è§¦åäºä»¶
    EventController.prototype._triggerEvent = function (type, ev) {
        var pointInfo = this._getPointInfo(ev);
        // æ¯æ¬¡é½è·åå¾å½¢æä¸å®ææ¬ï¼åæå¯ä»¥èèè¿è¡ç¼å­ç­ç¥
        var shape = this._getShape(pointInfo, ev);
        var method = this["_on" + type];
        var leaveCanvas = false;
        if (method) {
            method.call(this, pointInfo, shape, ev);
        }
        else {
            var preShape = this.currentShape;
            // å¦æè¿å¥ãç§»åºç»å¸æ¶å­å¨å¾å½¢ï¼åè¦åå«è§¦åäºä»¶
            if (type === 'mouseenter' || type === 'dragenter' || type === 'mouseover') {
                this._emitEvent(type, ev, pointInfo, null, null, shape); // åè¿å¥ç»å¸
                if (shape) {
                    this._emitEvent(type, ev, pointInfo, shape, null, shape); // åè§¦åå¾å½¢çäºä»¶
                }
                if (type === 'mouseenter' && this.draggingShape) {
                    // å¦ææ­£å¨ææ½å¾å½¢, åè§¦å dragleave
                    this._emitEvent('dragenter', ev, pointInfo, null);
                }
            }
            else if (type === 'mouseleave' || type === 'dragleave' || type === 'mouseout') {
                leaveCanvas = true;
                if (preShape) {
                    this._emitEvent(type, ev, pointInfo, preShape, preShape, null); // åè§¦åå¾å½¢çäºä»¶
                }
                this._emitEvent(type, ev, pointInfo, null, preShape, null); // åè§¦åç¦»å¼ç»å¸äºä»¶
                if (type === 'mouseleave' && this.draggingShape) {
                    this._emitEvent('dragleave', ev, pointInfo, null);
                }
            }
            else {
                this._emitEvent(type, ev, pointInfo, shape, null, null); // ä¸è¬äºä»¶ä¸­ä¸éè¦èè from, to
            }
        }
        if (!leaveCanvas) {
            this.currentShape = shape;
        }
        // å½é¼ æ ä»ç»å¸ç§»å¨å° shape æèä» preShape ç§»å¨å° shape æ¶ï¼åºç¨ shape ä¸çé¼ æ æ ·å¼
        if (shape && !shape.get('destroyed')) {
            var canvas = this.canvas;
            var el = canvas.get('el');
            el.style.cursor = shape.attr('cursor') || canvas.get('cursor');
        }
    };
    // è®°å½ä¸ç¹å»çä½ç½®ãå¾å½¢ï¼ä¾¿äºææ½äºä»¶ãclick äºä»¶çå¤å®
    EventController.prototype._onmousedown = function (pointInfo, shape, event) {
        // åªæé¼ æ å·¦é®ç mousedown äºä»¶æä¼è®¾ç½® mousedownShape ç­å±æ§ï¼é¿åé¼ æ å³é®ç mousedown äºä»¶å¼èµ·å¶ä»äºä»¶åç
        if (event.button === LEFT_BTN_CODE) {
            this.mousedownShape = shape;
            this.mousedownPoint = pointInfo;
            this.mousedownTimeStamp = event.timeStamp;
        }
        this._emitEvent('mousedown', event, pointInfo, shape, null, null); // mousedown ä¸èèfromShape, toShape
    };
    // mouseleave å mouseenter é½æ¯æå¯¹å­å¨ç
    // mouseenter å mouseover åæ¶è§¦å
    EventController.prototype._emitMouseoverEvents = function (event, pointInfo, fromShape, toShape) {
        var el = this.canvas.get('el');
        if (fromShape !== toShape) {
            if (fromShape) {
                this._emitEvent('mouseout', event, pointInfo, fromShape, fromShape, toShape);
                this._emitEvent('mouseleave', event, pointInfo, fromShape, fromShape, toShape);
                // å½é¼ æ ä» fromShape ç§»å¨å°ç»å¸ä¸æ¶ï¼éç½®é¼ æ æ ·å¼
                if (!toShape || toShape.get('destroyed')) {
                    el.style.cursor = this.canvas.get('cursor');
                }
            }
            if (toShape) {
                this._emitEvent('mouseover', event, pointInfo, toShape, fromShape, toShape);
                this._emitEvent('mouseenter', event, pointInfo, toShape, fromShape, toShape);
            }
        }
    };
    // dragover ä¸ç­åäº mouseoverï¼èç­åäº mousemove
    EventController.prototype._emitDragoverEvents = function (event, pointInfo, fromShape, toShape, isCanvasEmit) {
        if (toShape) {
            if (toShape !== fromShape) {
                if (fromShape) {
                    this._emitEvent('dragleave', event, pointInfo, fromShape, fromShape, toShape);
                }
                this._emitEvent('dragenter', event, pointInfo, toShape, fromShape, toShape);
            }
            if (!isCanvasEmit) {
                this._emitEvent('dragover', event, pointInfo, toShape);
            }
        }
        else if (fromShape) {
            // TODO: æ­¤å¤å¤æ­æé®é¢ï¼å½ drag å¾å½¢æ¶ï¼ä¹ä¼è§¦åä¸æ¬¡ dragleave äºä»¶ï¼å ä¸ºæ­¤æ¶ toShape ä¸º nullï¼è¿ä¸æ¯æææç
            // ç»è¿ç©ºç½åºå
            this._emitEvent('dragleave', event, pointInfo, fromShape, fromShape, toShape);
        }
        if (isCanvasEmit) {
            this._emitEvent('dragover', event, pointInfo, toShape);
        }
    };
    // drag å®æåï¼éè¦åä¸äºæ¸çå·¥ä½
    EventController.prototype._afterDrag = function (draggingShape, pointInfo, event) {
        if (draggingShape) {
            draggingShape.set('capture', true); // æ¢å¤å¯ä»¥æ¾å
            this.draggingShape = null;
        }
        this.dragging = false;
        // drag å®æåï¼æå¯è½ draggingShape å·²ç»ç§»å¨å°äºå½åä½ç½®ï¼æä»¥ä¸è½ç´æ¥åå½åå¾å½¢
        var shape = this._getShape(pointInfo, event);
        // ææ½å®æåï¼è¿è¡ enterï¼leave çå¤å®
        if (shape !== draggingShape) {
            this._emitMouseoverEvents(event, pointInfo, draggingShape, shape);
        }
        this.currentShape = shape; // æ´æ°å½å shapeï¼å¦æä¸å¤çå½åå¾å½¢ç mouseleave äºä»¶å¯è½ä¼åºé®é¢
    };
    // æé®æ¬èµ·æ¶ï¼ä¼ç»æ­¢ææ½ãè§¦åç¹å»
    EventController.prototype._onmouseup = function (pointInfo, shape, event) {
        // eevent.button === 0 è¡¨ç¤ºé¼ æ å·¦é®äºä»¶ï¼æ­¤å¤å ä¸å¤æ­ä¸»è¦æ¯ä¸ºäºé¿åå³é®é¼ æ ä¼è§¦å mouseup å click äºä»¶
        // ref: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (event.button === LEFT_BTN_CODE) {
            var draggingShape = this.draggingShape;
            if (this.dragging) {
                // å­å¨å¯ä»¥ææ½çå¾å½¢ï¼åæ¶ææ½å°å¶ä»å¾å½¢ä¸æ¶è§¦å drag äºä»¶
                if (draggingShape) {
                    this._emitEvent('drop', event, pointInfo, shape);
                }
                this._emitEvent('dragend', event, pointInfo, draggingShape);
                this._afterDrag(draggingShape, pointInfo, event);
            }
            else {
                this._emitEvent('mouseup', event, pointInfo, shape); // åè§¦å mouseup åè§¦å click
                if (shape === this.mousedownShape) {
                    this._emitEvent('click', event, pointInfo, shape);
                }
                this.mousedownShape = null;
                this.mousedownPoint = null;
            }
        }
    };
    // å½è§¦åæµè§å¨ç dragover äºä»¶æ¶ï¼ä¸ä¼åè§¦å mousemove ï¼æä»¥è¿æ¶åç dragenter, dragleave äºä»¶éè¦éæ°å¤ç
    EventController.prototype._ondragover = function (pointInfo, shape, event) {
        event.preventDefault(); // å¦æä¸å¯¹ dragover è¿è¡ preventDefaultï¼åä¸ä¼å¨ canvas ä¸è§¦å drop äºä»¶
        var preShape = this.currentShape;
        this._emitDragoverEvents(event, pointInfo, preShape, shape, true);
    };
    // å¤§éçå¾å½¢äºä»¶ï¼é½éè¿ mousemove æ¨¡æ
    EventController.prototype._onmousemove = function (pointInfo, shape, event) {
        var canvas = this.canvas;
        var preShape = this.currentShape;
        var draggingShape = this.draggingShape;
        // æ­£å¨ææ½æ¶
        if (this.dragging) {
            // æ­£å¨ææ½ä¸­
            if (draggingShape) {
                // å¦æææ½äº shape ä¼è§¦å dragenter, dragleave, dragover å drag äºä»¶
                this._emitDragoverEvents(event, pointInfo, preShape, shape, false);
            }
            // å¦æå­å¨ draggingShape åä¼å¨ draggingShape ä¸è§¦å drag äºä»¶ï¼åæ³¡å° canvas ä¸
            // å¦åå¨ canvas ä¸è§¦å drag äºä»¶
            this._emitEvent('drag', event, pointInfo, draggingShape);
        }
        else {
            var mousedownPoint = this.mousedownPoint;
            if (mousedownPoint) {
                // å½é¼ æ ç¹å»ä¸å»ï¼åæ¶ç§»å¨æ¶ï¼è¿è¡ drag å¤å®
                var mousedownShape = this.mousedownShape;
                var now = event.timeStamp;
                var timeWindow = now - this.mousedownTimeStamp;
                var dx = mousedownPoint.clientX - pointInfo.clientX;
                var dy = mousedownPoint.clientY - pointInfo.clientY;
                var dist = dx * dx + dy * dy;
                if (timeWindow > 120 || dist > CLICK_OFFSET) {
                    if (mousedownShape && mousedownShape.get('draggable')) {
                        // è®¾ç½®äº draggable ç shape æè½è§¦å drag ç¸å³çäºä»¶
                        draggingShape = this.mousedownShape; // æå¨é¼ æ ç¹ä¸æ¶ç shape
                        draggingShape.set('capture', false); // ç¦æ­¢ç»§ç»­æ¾åï¼å¦åæ æ³è¿è¡ dragover,dragenter,dragleave,dropçå¤å®
                        this.draggingShape = draggingShape;
                        this.dragging = true;
                        this._emitEvent('dragstart', event, pointInfo, draggingShape);
                        // æ¸çæä¸é¼ æ æ¶ç¼å­çå¼
                        this.mousedownShape = null;
                        this.mousedownPoint = null;
                    }
                    else if (!mousedownShape && canvas.get('draggable')) {
                        // è®¾ç½®äº draggable ç canvas æè½è§¦å drag ç¸å³çäºä»¶
                        this.dragging = true;
                        this._emitEvent('dragstart', event, pointInfo, null);
                        // æ¸çæä¸é¼ æ æ¶ç¼å­çå¼
                        this.mousedownShape = null;
                        this.mousedownPoint = null;
                    }
                    else {
                        this._emitMouseoverEvents(event, pointInfo, preShape, shape);
                        this._emitEvent('mousemove', event, pointInfo, shape);
                    }
                }
                else {
                    this._emitMouseoverEvents(event, pointInfo, preShape, shape);
                    this._emitEvent('mousemove', event, pointInfo, shape);
                }
            }
            else {
                // æ²¡ææé®æä¸æ¶ï¼åç´æ¥è§¦å mouse over ç¸å³çåç§äºä»¶
                this._emitMouseoverEvents(event, pointInfo, preShape, shape);
                // å§ç»è§¦åç§»å¨
                this._emitEvent('mousemove', event, pointInfo, shape);
            }
        }
    };
    // è§¦åäºä»¶
    EventController.prototype._emitEvent = function (type, event, pointInfo, shape, fromShape, toShape) {
        var eventObj = this._getEventObj(type, event, pointInfo, shape, fromShape, toShape);
        // å­å¨ shape è§¦åï¼åè¿è¡åæ³¡å¤ç
        if (shape) {
            eventObj.shape = shape;
            // è§¦å shape ä¸çäºä»¶
            emitTargetEvent(shape, type, eventObj);
            var parent_1 = shape.getParent();
            // æ§è¡åæ³¡
            while (parent_1) {
                // å§æäºä»¶è¦åè§¦å
                parent_1.emitDelegation(type, eventObj);
                // äºä»¶åæ³¡åæ­¢ï¼ä¸è½å¦¨ç¢å§æäºä»¶
                if (!eventObj.propagationStopped) {
                    bubbleEvent(parent_1, type, eventObj);
                }
                eventObj.propagationPath.push(parent_1);
                parent_1 = parent_1.getParent();
            }
        }
        else {
            // å¦ææ²¡æ shape ç´æ¥å¨ canvas ä¸è§¦å
            var canvas = this.canvas;
            // ç´æ¥è§¦å canvas ä¸çäºä»¶
            emitTargetEvent(canvas, type, eventObj);
        }
    };
    EventController.prototype.destroy = function () {
        // æ¸çäºä»¶
        this._clearEvents();
        // æ¸çç¼å­çå¯¹è±¡
        this.canvas = null;
        this.currentShape = null;
        this.draggingShape = null;
        this.mousedownPoint = null;
        this.mousedownShape = null;
        this.mousedownTimeStamp = null;
    };
    return EventController;
}());
export default EventController;
//# sourceMappingURL=event-contoller.js.map